import type { ReactNode } from 'react';

interface Props {
  title?: string;
  children: ReactNode;
}

export function SettingsGroup({ title, children }: Props) {
  return (
    <section className="profile-card">
      {title ? <div className="profile-card-title">{title}</div> : null}
      {children}
    </section>
  );
}
